var Model = require('../Model');

var aggregate = Object.create(Model);
aggregate.name = 'Aggregate';
aggregate['@class'] = 'Aggregate';
aggregate.url = 'aggregate';
aggregate.fields = {
  name: {
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 3, maximum: 128, default: ''}
    }
  },
  func: {
    presence: true, 
    default: 'summation'
  },
  formula: {
    length: {default: ''},
    default: null,
    validators: {
      formula: {}
    }
  }
}

module.exports = aggregate;
